import { StateCreator } from 'zustand'
import { SharedSlice } from '../../../slice'
import { PayClassification } from '$models'
import { exceptionMessageHandler } from '$utils'
import { payClassificationService } from '$services'

interface ComplianceSharedState {
  payClassifications: PayClassification[]
}

export interface ComplianceSharedSlice extends ComplianceSharedState {
  /**
   * Get Pay Classifications list
   */
  getPayClassifications: () => Promise<PayClassification[]>

  /**
   * Resets PayClassifications Slice state
   */
  resetComplianceSharedSlice: () => void
}

const initialState: ComplianceSharedState = {
  payClassifications: [],
}

const createPayClassificationsSlice: StateCreator<
  ComplianceSharedSlice & SharedSlice,
  [],
  [],
  ComplianceSharedSlice
> = (set) => ({
  ...initialState,

  resetComplianceSharedSlice: () => set(initialState),

  getPayClassifications: async (): Promise<PayClassification[]> => {
    try {
      const response = await payClassificationService.getAll()
      set(() => ({
        payClassifications: response,
      }))
      return response
    } catch (error) {
      set(() => ({
        payClassifications: [],
      }))
      exceptionMessageHandler(error, 'Failed to retrieve pay classifications')
      return []
    } finally {
      set(() => ({ isLoading: false }))
    }
  },
})

export default createPayClassificationsSlice
